import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import Routes from './routes'
import lodash from 'lodash'; 
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import Vuetify from 'vuetify'
import DmAuth from './packages/dmAuth/DmAuth.js'
import DmMessages from './packages/dmMessages/DmMessages.js'
import axios from 'axios'
import {store} from './store'
import VeeValidate from 'vee-validate';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import XHR from 'i18next-xhr-backend';
import resources from '../locales'


//Object.defineProperty(Vue.prototype, '$_', { value: lodash });
Object.defineProperty(Vue.prototype, '$axios', { value: axios });


//Vue.component('icon', Icon);

Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(DmAuth);
Vue.use(DmMessages);
Vue.use(VueLodash, lodash);
Vue.use(VueI18Next);

Vue.use(VeeValidate,{
    inject:false
    
});
axios.defaults.baseURL = 'https://iglu.coparts.de/';
//axios.defaults.baseURL = 'http://ipartnerdb/';

axios.interceptors.request.use(
function(config) {
    
    config.headers = {
        //Authorization: "Bearer " + Vue.dmAuth.getToken(),
        //Accept: 'application/json',
        //'X-Requested-With': 'XMLHttpRequest'
    };
    return config
}, (error) => {
        console.log('request failed')
        return Promise.reject(error)
})



/*i18next
    .use(XHR)
    .init({
        'debug': true,
        'lng': 'en',
        'fallbackLng': 'en',
        backend: {
            loadPath: axios.defaults.baseURL + '/resources/locales/{{ns}}.{{lng}}.json'
        }
});
*/
i18next.init({
    'debug' : true,
    'lng':'en',
    'fallbackLng': 'en',
    'resources':resources,
})
const i18n = new VueI18Next(i18next);
const router = new VueRouter({
    routes: Routes,
    mode: 'history'
});

router.beforeEach(function(to, from, next){

    if(to.matched.some(record => record.meta.forVisitors)) {
        if (Vue.dmAuth.isAuthenticated()) {
            next({
                path: '/dashboard'
            })        
        } else next()
    } else if(to.matched.some(record => record.meta.forAuth)) {
        if (! Vue.dmAuth.isAuthenticated()) {
            next({
                path: '/login'
            })        
        } else next()
    }
})

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.event = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target) || event.target.name == "search")) {
        // and if it did, call method provided in attribute value        
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.event)
  },
});

new Vue({
    
    el: '#app',  
    render: h => h(App),
    router: router,
    store:store,
    i18n:i18n,
    created: function() {
        
        store.commit('clearMessages')
        
        if(!Vue.dmAuth.isAuthenticated() && store.getters.isAuth == true) {
            store.commit('setAuth')
        } else {
            store.dispatch('setAuthenticatedUser').then(()=>{
                
            })
        }
        
        
    }
});



// WEBPACK FOOTER //
// ./src/main.js